import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import AceJsonReader from './AceJsonReader'
import CopyButton from './CopyButton'

const useStyles = makeStyles(() => ({
  wrap: {
    border: '1px solid var(--color-neutral-200)',
    borderRadius: 'var(--border-radius-sm, 4px)'
  },
  header: {
    padding: '6px 10px',
    borderBottom: '1px solid var(--color-neutral-200)',
    backgroundColor: 'var(--color-neutral-050)',
    fontSize: 10,
    letterSpacing: '0.4px',
    color: 'var(--color-neutral-500)'
  }
}))

function stringify (value) {
  if (value === undefined) return ''
  if (value === null) return 'null'
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value)
  }
}

export default function InspectorJsonView ({ value, headerLabel, copyLabel = 'copy', name = 'ddp-inspector-json' }) {
  const classes = useStyles()
  const text = useMemo(() => stringify(value), [value])

  return (
    <div className={`${classes.wrap} flex flex-col flex-1 min-h-0 overflow-hidden bg-white`}>
      {(headerLabel || copyLabel) && (
        <div className={`${classes.header} flex items-center justify-between font-mono uppercase font-bold flex-shrink-0`}>
          <span>{headerLabel}</span>
          {copyLabel && <CopyButton value={value} label={copyLabel} />}
        </div>
      )}
      <AceJsonReader name={name} value={text} />
    </div>
  )
}

InspectorJsonView.propTypes = {
  value: PropTypes.any,
  headerLabel: PropTypes.node,
  copyLabel: PropTypes.string,
  name: PropTypes.string
}
